import React, { useEffect, useRef, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import Logo from '@/components/01_atoms/Logo/Logo';
import MenuIcon from '@material-ui/icons/Menu';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles, createStyles, withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Toolbar from '@material-ui/core/Toolbar';
import Popper from '@material-ui/core/Popper';
import IconButton from '@material-ui/core/IconButton';
import { Grid, Typography } from '@material-ui/core';
import HoverDropdownMenu from '@/components/03_organisms/GlobalHeader/HoverDropdownMenu';
import TeeTimeIcon from '../../../public/assets/home.svg';
import HomeIcon from '../../../public/assets/home.svg';
import ShopIcon from '../../../public/assets/shop.svg';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      height: 'auto !imoirtant',
      display: 'flex',
      paddingLeft: '80px',
      paddingTop: '20px',
      [theme.breakpoints.down('sm')]: {
        backgroundColor: 'white',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '20px',
      },
    },
    textCenter: {
      textAlign: 'center',
    },
    appBar: {
      backgroundColor: 'transparent !important',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      display: 'inline-block',
      zIndex: 100,
      '& p': {
        color: theme.palette.grey[700],
      },
    },

    accordionItem: {
      fontSize: '18px',
      color: 'black',
      fontWeight: 700,
      fontStyle: 'Lato',
      margin: '12px 0',
    },
    utilityMenu: {
      position: 'relative',
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end',
      fontSize: 16,
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
      '& li ': {
        padding: 0,
        width: 'auto',
        '&  .MuiPaper-root ': {
          backgroundColor: 'transparent !important',
        },
      },
      '& a ': {
        color: theme.palette.grey[900],
        padding: '0 .75rem',
        display: 'flex',
        alignItems: 'inherit',
        fontWeight: 700,
        lineHeight: 2,

        [theme.breakpoints.down('sm')]: {
          fontSize: '.75rem',
          padding: '0 .5rem',
        },

        '&:hover': {
          color: theme.palette.primary,
        },
      },
      '& li:last-child a': {
        paddingRight: 0,
      },

      '& svg ': {
        width: 24,
        height: 24,
        margin: '0 .5rem 0 0',
        [theme.breakpoints.down('sm')]: {
          width: 16,
          margin: '0 .25rem 0 0',
        },
      },
    },
    '& .residentLogin svg': {
      width: 18,
      height: 18,
    },
    mainMenuAccordions: {
      display: 'flex',
      background: 'transparent',
      border: 0,
      justifyContent: 'center',
      marginLeft: 'auto',
      padding: '0 20px',
      [theme.breakpoints.down('sm')]: {
        '& .divider': {
          width: '100%',
          background: 'black',
          borderBottom: '1px solid black',
          margin: '20px 0px',
        },
        flexDirection: 'column',
        justifyContent: 'start',
        background: 'white',
      },
      '& .MuiAccordion-root': {
        margin: '0 !important',
        border: 'none',
        [theme.breakpoints.up('md')]: {
          paddingTop: '1rem',
        },
        '& li': {
          padding: 0,
          width: '100%',
          display: 'block',
        },
        '&  span, & a': {
          display: 'block',
          color: theme.palette.grey[900],
          fontFamily: 'Playfair Display',
          fontSize: 18,
          fontWeight: 700,
          padding: '0 1rem',
          textTransform: 'uppercase',
          [theme.breakpoints.down('sm')]: {
            fontSize: 18,
            padding: '0',
          },
          [theme.breakpoints.up('md')]: {
            fontSize: 16,
          },
          [theme.breakpoints.up('lg')]: {
            fontSize: 20,
          },
        },
        '& svg': {
          width: '.75rem',
          [theme.breakpoints.down('sm')]: {
            width: '.85rem',
          },
        },
        '& .Mui-expanded span': {
          color: theme.palette.primary.main,
        },
        '& a': {
          padding: '.5rem 1rem',
          [theme.breakpoints.down('sm')]: {
            padding: '0',
          },
        },
        '& ul a': {
          textTransform: 'none',
        },
        '& li li a': {
          fontWeight: 400,
        },
      },
      '& .MuiAccordionDetails-root': {
        background: 'white',
        position: 'absolute', // Use 'fixed' if you want it to be relative to the viewport
        width: '100%', // Take full width
        left: 0, // Align to the left edge of the container
        top: '100%', // Position below the parent Accordion
        border: 0,
        boxShadow: '0px 9px 9px rgb(0 0 0 / 5%)',
        [theme.breakpoints.up('md')]: {
          position: 'absolute',
          minWidth: '100%', // Ensure it takes the full width
          left: 0,
          top: '5rem',
          padding: '0',
        },
        [theme.breakpoints.down('md')]: {
          position: 'static',
          padding: 0,
          boxShadow: 'none',
          '& span': {
            padding: 0,
          },
        },
        '& ul': {
          width: '100%',
        },
        '& li li a': {
          paddingLeft: '1.75rem !important',
        },
        '& a': {
          display: 'block',
          padding: '.2rem 0',
          fontSize: '18px !important',
          [theme.breakpoints.down('sm')]: {
            fontSize: '16px !important',
          },
        },
        '& a:hover': {
          backgroundColor: theme.palette.grey[200],
          textDecoration: 'none',
        },
      },
      '& svg': {
        transform: 'rotate(0deg)',
      },
      '& .Mui-expanded svg': {
        transform: 'rotate(180deg)',
      },
    },
    topMenuAccordions: {
      paddingRight: '80px',
      '& .MuiAccordion-root': {
        position: 'relative',
        margin: '0 !important',
        border: 'none',
        '& .MuiAccordionSummary-root': {
          minHeight: 'auto',
          padding: '0 8px',
        },

        '& .MuiAccordionSummary-content': {
          margin: 0,
        },

        '& li': {
          padding: 0,
          width: '100%',
          display: 'block',
        },

        '&  span, & a': {
          display: 'block',
          padding: '0 12px',
          color: '#000000',
          fontWeight: '700',
          lineHeight: 2,
          [theme.breakpoints.down('sm')]: {
            padding: '0 .5rem',
            fontSize: '.75rem',
          },
        },
        '& svg': {
          width: '.75rem',
          [theme.breakpoints.down('sm')]: {
            width: '.5rem',
          },
        },
        '& .Mui-expanded span': {
          color: theme.palette.primary.main,
        },
        '& a': {
          padding: '.5rem 1rem',
        },
        '& ul a': {
          textTransform: 'none',
        },
        '& li li a': {
          fontWeight: 400,
        },
      },
      '& .MuiAccordionDetails-root': {
        background: 'white',
        border: 0,
        boxShadow: '0px 9px 9px rgb(0 0 0 / 5%)',
        position: 'absolute',
        minWidth: 300,
        left: '1rem',
        top: '2rem',
        padding: '0',
        zIndex: 5,
        [theme.breakpoints.down('sm')]: {
          left: '0',
          minWidth: 200,
        },
        '& ul': {
          width: '100%',
        },
        '& li li a': {
          paddingLeft: '1.75rem !important',
        },
        '& a': {
          display: 'block',
          padding: '.2rem 0',
        },
        '& a:hover': {
          backgroundColor: theme.palette.grey[200],
          textDecoration: 'none',
        },
      },
      '& svg': {
        transform: 'rotate(0deg)',
      },
      '& .Mui-expanded svg': {
        transform: 'rotate(180deg)',
      },
    },
    ctaContainer: {
      textAlign: 'right',
    },
    headline: {
      color: '#212121',
      fontFamily: 'Playfair Display',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '27px',
      margin: '0px',
    },
    headlineContainer: {
      '& svg': {
        width: 'auto !important',
        [theme.breakpoints.down('sm')]: {
          width: '23px !important',
        },
        transform: 'rotate(0deg) !important',
      },
      display: 'flex',
      alignItems: 'center',
      height: '50px',
      paddingLeft: '20px',
      marginBottom: '24px',
      backgroundColor: '#F8F3E6',
      borderRadius: '0px 365px 365px 0px',
      margin: '0px',
      cursor: 'pointer',
    },
    headerCta: {
      marginTop: '.75rem',
      marginLeft: 'auto',
      fontSize: '1rem !important',
      padding: '1.125rem 1.5rem !important',
      [theme.breakpoints.up('lg')]: {
        fontSize: '1.25rem !important',
        padding: '1.125rem 2.75rem !important',
      },
    },
    aboutList: {
      '& a': {
        marginBottom: '18px',
      },
    },
    actionContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      paddingTop: '23px',
      paddingBottom: '20px',
      backgroundColor: '#F8F8F8',
      width: 'calc(100% + 40px)',
      margin: '0 -20px',
      '& svg': {
        width: 'auto !important',
        transform: 'rotate(0deg) !important',
      },
      '& a>a>div ': {
        padding: '0 20px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '28px',
      },
    },
    title: {
      fontFamily: 'Playfair Display',
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '27px',
      letterSpacing: '0%',
      margin: '0',
    },
    description: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '22px',
      letterSpacing: '0%',
      margin: 0,
    },
    headerCtaResp: {
      fontSize: '1rem !important',
      padding: '1rem 1rem !important',
      margin: '20px 0',
    },

    headerCtaDesktop: {
      fontSize: '.745rem !important',
      padding: '1.125rem 1.75rem !important',
      [theme.breakpoints.up('lg')]: {
        fontSize: '1.25rem !important',
        padding: '1.125rem 2.75rem !important',
      },
    },
    mainMenuItem: {
      padding: '0 !important',
      '& span': {
        display: 'block',
        marginBottom: 0,
      },
    },
    hideOnMobile: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    logoContainer: {
      justifyContent: 'space-between',
      '& img': {
        [theme.breakpoints.down('sm')]: {
          maxWidth: '86px !important',
          width: '86px',
        },
      },
    },
    iconStyles: {
      padding: 0,
      marginLeft: 'auto',
      // color: 'white',
      '& svg': {
        height: '2em',
        width: '2em',
        [theme.breakpoints.down('sm')]: {
          width: '1em',
          height: '1em',
        },
      },
    },
    popoverStyles: {
      transform: 'translate3d(0px, 169px, 0px) !important',
      width: '100%',
      zIndex: 100,
      [theme.breakpoints.down('sm')]: {
        transform: 'translate3d(0px, 100px, 0px) !important',
      },
    },
    navbarContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      background: 'white',
      borderBottomLeftRadius: '365px',
      borderTopLeftRadius: '365px',
      paddingRight: '80px',
      paddingLeft: '64px',
      position: 'relative',
      zIndex: '200',
      [theme.breakpoints.down('sm')]: {
        paddingRight: '20px',
        paddingLeft: '20px',
      },
    },
    listItems: {
      padding: 0,
      marginBottom: '24px',
      [theme.breakpoints.down('sm')]: {
        '& a': {
          marginBottom: '20px',
          fontSize: '16px !important',
          paddingLeft: '12px !important',
        },
      },
    },
  })
);

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    height: 'auto',
    minHeight: 56,
    top: 0,
    '& span': {
      [theme.breakpoints.down('sm')]: {
        padding: '0 !important',
        fontSize: '18px !important',
      },
    },
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'start',
      gap: '6px',
    },
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: '16px 0',
    },
    position: 'static',
    width: '100%',
    left: 0,
    top: '100%',
    zIndex: 999,
    background: 'white',
    boxShadow: '0px 9px 9px rgb(0 0 0 / 5%)',
  },
}))(MuiAccordionDetails);

export default function TemporaryDrawer(props) {
  const { menu } = props;
  const classes = useStyles();
  const logo = '/assets/baywood-greens-logo.svg';

  const [expanded, setExpanded] = useState(false);
  const [activeInnerItem, setActiveInnerItem] = useState(null);
  const [activeInnerItemMobile, setActiveInnerItemMobile] = useState(null);
  const [menuCallActions, setMenuCallActions] = useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleNavbarChange = (panel, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const origin = window.location.origin;

      setMenuCallActions([
        {
          id: 1,
          title: 'Book a Tee Time',
          description: 'Ready to hit the course? Find a time that works.',
          icon: <TeeTimeIcon />,
          url: `${origin}/golf/tee-times`,
        },
        {
          id: 2,
          title: 'Stay & Play Packages',
          description: 'Tailored golf packages to make your stay enjoyable.',
          icon: <HomeIcon />,
          url: `${origin}/golf/packages`,
        },
        {
          id: 3,
          title: 'Pro Shop & Apparel',
          description: 'Find gift cards, comfortable golf clothes and more.',
          icon: <ShopIcon />,
          url: `${origin}/golf/pro-shop`,
        },
      ]);
    }
  }, []);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const showCallActions =
    menu?.['#items'] &&
    Object.entries(menu['#items']).findIndex(
      ([key]) => activeInnerItemMobile === key
    ) === 2;

  const main_menu = (
    <Box displayPrint="none">
      {menu && menu['#items'] && (
        <Box className={classes.mainMenuAccordions}>
          {Object.entries(menu['#items']).map(([key, item]) => {
            let inner_lvl1 = [],
              inner_lvl2 = [],
              uniqueID1;
            let uniqueID = key.substring(key.length - 7);

            inner_lvl2 = [];
            if (
              item.below &&
              (item.below.length > 0 || Object.keys(item.below).length)
            ) {
              for (const [key1, item1] of Object.entries(item.below)) {
                let parent = null;
                uniqueID1 = key1.substring(key1.length - 7);
                if (key1.includes('menu_link_content:')) {
                  parent = {
                    title: item1.title,
                    href: item1.url,
                    key: uniqueID1,
                  };

                  if (
                    item1.below &&
                    (item1.below.length > 0 || Object.keys(item1.below).length)
                  ) {
                    for (const [key2, item2] of Object.entries(item1.below)) {
                      if (key2.includes('menu_link_content:')) {
                        let uniqueID2 = key1.substring(key2.length - 7);
                        inner_lvl2.push({
                          title: item2.title,
                          href: item2.url,
                          key: uniqueID2,
                        });
                      }
                    }
                    parent['below'] = inner_lvl2;
                  }
                  inner_lvl1.push(parent);
                  inner_lvl2 = [];
                }
              }
            }

            return (
              <Accordion
                expanded={expanded === `nav-${uniqueID}`}
                key={`acc-${uniqueID}`}
                onMouseLeave={() =>
                  handleNavbarChange(`nav-${uniqueID}`, false)
                }
                onChange={() =>
                  handleNavbarChange(`nav-${uniqueID}`, !expanded)
                }
              >
                <AccordionSummary
                  aria-controls={`${uniqueID}-content`}
                  id={`${uniqueID}-header`}
                  style={{
                    padding: '0px',
                  }}
                  onClick={() => {
                    setActiveInnerItemMobile(key);
                  }}
                >
                  <span>{item.title}</span>
                  <svg
                    width="22"
                    height="14"
                    viewBox="0 0 22 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.56667 0.26683L1.31174e-07 2.8335L11 13.8335L22 2.8335L19.4333 0.26683L11 8.70016L2.56667 0.26683Z"
                      fill="#C4C4C4"
                    />
                  </svg>
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    background: 'white',
                    boxShadow: 'none',
                    border: 0,
                    position: 'unset',
                    padding: '0',
                    zIndex: 5,
                    flexDirection: 'column',
                    '& ul': {
                      width: '100%',
                    },
                    '& li li a': {
                      paddingLeft: '0 !important',
                    },
                    '& a': {
                      display: 'block',
                      padding: '.2rem 0',
                    },
                    '& a:hover': {
                      textDecoration: 'none',
                    },
                  }}
                >
                  {inner_lvl1.length > 0 && (
                    <List>
                      {inner_lvl1.map((item11, key11) => {
                        return (
                          <ListItem key={key11}>
                            <MenuHeadline
                              headline={item11.title}
                              url={item11.href}
                            />

                            {item11['below']?.length > 0 && (
                              <List className={classes.listItems}>
                                {item11['below'].map((item12, key12) => {
                                  return (
                                    <Link
                                      href={item12.href}
                                      title={item12.title}
                                    >
                                      {item12.title}
                                    </Link>
                                  );
                                })}
                              </List>
                            )}
                          </ListItem>
                        );
                      })}
                    </List>
                  )}
                  {showCallActions && (
                    <Box className={classes.actionContainer}>
                      {menuCallActions.map((item, index) => (
                        <Link href={item.url} key={index} passHref>
                          <a
                            className={classes.childLink}
                            onClick={() => setActiveInnerItem(null)}
                          >
                            <Box
                              key={`menu-call-action-${item.id}`}
                              className={classes.actionLink}
                            >
                              <Box
                                style={{
                                  paddingRight: '0',
                                }}
                              >
                                {item.icon}
                              </Box>
                              <Box>
                                <Typography className={classes.title}>
                                  {item.title}
                                </Typography>
                                <Typography className={classes.description}>
                                  {item.description}
                                </Typography>
                              </Box>
                            </Box>
                          </a>
                        </Link>
                      ))}
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}

          <div className="divider" />

          <Accordion
            key={`menu-exp-about`}
            expanded={expanded === `nav-top-about`}
            onChange={handleChange(`nav-top-about`)}
          >
            <AccordionSummary
              style={{
                padding: '0px',
              }}
              aria-controls={`top-about-content`}
              id={`top-about-header`}
            >
              <span>ABOUT</span>
              <svg
                width="22"
                height="14"
                viewBox="0 0 22 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.56667 0.26683L1.31174e-07 2.8335L11 13.8335L22 2.8335L19.4333 0.26683L11 8.70016L2.56667 0.26683Z"
                  fill="#000"
                />
              </svg>
            </AccordionSummary>
            <AccordionDetails>
              <List className={classes.aboutList}>
                <Link href="/contact">
                  <span>Contact</span>
                </Link>
                <Link href="/baywood-greens-site-plan">
                  <span>Site Plan</span>
                </Link>
                <Link
                  href="https://jobs.teamengine.io/potnets"
                  rel="noopener"
                  target="_blank"
                >
                  <span>Careers</span>
                </Link>
                <Link href="/about-tunnell-companies/disclaimer">
                  <span>Disclaimer</span>
                </Link>
                <Link href="/about-tunnell-companies/privacy-policy">
                  <span>Privacy Policy</span>
                </Link>
              </List>
            </AccordionDetails>
          </Accordion>
          <Link className={classes.accordionItem} href="/golf/tee-times">
            <span>BOOK A TEE-TIME</span>
          </Link>
          <Link
            className={classes.accordionItem}
            href="https://payments.tunnellcompanies.com/customerPortal/login.aspx?ReturnUrl=%2fcustomerPortal%2f"
            rel="noopener"
            target="_blank"
          >
            <span>LOGIN</span>
          </Link>
          <Button
            className={classes.headerCtaResp}
            size="large"
            href="/living/homes/pre-owned"
            disableElevation
            variant="contained"
            color="primary"
          >
            FIND A HOME
          </Button>
        </Box>
      )}
    </Box>
  );

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          elevation={0}
          position="relative"
          className={clsx(classes.appBar)}
        >
          <Grid item xs={12}>
            <Box
              className={classes.topMenuAccordions}
              displayPrint="none"
              style={{
                position: 'relative',
                zIndex: 999,
              }}
            >
              <Hidden smDown>
                <List
                  className={classes.utilityMenu}
                  style={{ backgroundColor: 'transparent !important' }}
                >
                  <ListItem
                    key={`utility1`}
                    style={{ backgroundColor: 'transparent !important' }}
                  >
                    <Accordion
                      style={{ backgroundColor: 'transparent !important' }}
                      key={`menu-exp-about`}
                      expanded={expanded === `nav-top-about`}
                      onChange={handleChange(`nav-top-about`)}
                    >
                      <AccordionSummary
                        style={{ backgroundColor: 'transparent !important' }}
                        aria-controls={`top-about-content`}
                        id={`top-about-header`}
                      >
                        <span>ABOUT</span>
                        <svg
                          width="22"
                          height="14"
                          viewBox="0 0 22 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M2.56667 0.26683L1.31174e-07 2.8335L11 13.8335L22 2.8335L19.4333 0.26683L11 8.70016L2.56667 0.26683Z"
                            fill="#000"
                          />
                        </svg>
                      </AccordionSummary>
                      <AccordionDetails>
                        <List>
                          <ListItem key={`utility5`}>
                            <Link href="/contact">
                              <span>Contact</span>
                            </Link>
                            <Link href="/baywood-greens-site-plan">
                              <span>Site Plan</span>
                            </Link>
                            <Link
                              href="https://jobs.teamengine.io/potnets"
                              rel="noopener"
                              target="_blank"
                            >
                              <span>Careers</span>
                            </Link>
                            <Link href="/about-tunnell-companies/disclaimer">
                              <span>Disclaimer</span>
                            </Link>
                            <Link href="/about-tunnell-companies/privacy-policy">
                              <span>Privacy Policy</span>
                            </Link>
                          </ListItem>
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  </ListItem>
                  <ListItem key={`utility2`}>
                    <Link href="/golf/tee-times">
                      <span>BOOK A TEE-TIME</span>
                    </Link>
                  </ListItem>
                  <ListItem key={`utility4`}>
                    <Link
                      href="https://payments.tunnellcompanies.com/customerPortal/login.aspx?ReturnUrl=%2fcustomerPortal%2f"
                      rel="noopener"
                      target="_blank"
                    >
                      <span>LOGIN</span>
                    </Link>
                  </ListItem>
                </List>
              </Hidden>
            </Box>
          </Grid>
          <Toolbar disableGutters className={classes.logoContainer}>
            <div>
              <Logo
                width={150}
                height={'100%'}
                alt="Baywood Greens"
                name={logo}
              />
            </div>

            <Box className={classes.navbarContainer}>
              <Hidden smDown>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  {menu && menu['#items'] && (
                    <Box className={classes.mainMenuAccordions}>
                      {Object.entries(menu['#items']).map(([key, item], i) => {
                        let inner_lvl1 = [],
                          inner_lvl2 = [],
                          uniqueID1;
                        let uniqueID = key.substring(key.length - 7);

                        inner_lvl2 = [];
                        if (
                          item.below &&
                          (item.below.length > 0 ||
                            Object.keys(item.below).length)
                        ) {
                          for (const [key1, item1] of Object.entries(
                            item.below
                          )) {
                            let parent = null;
                            uniqueID1 = key1.substring(key1.length - 7);
                            if (key1.includes('menu_link_content:')) {
                              parent = {
                                title: item1.title,
                                href: item1.url,
                                key: uniqueID1,
                                index: i + 1,
                              };

                              if (
                                item1.below &&
                                (item1.below.length > 0 ||
                                  Object.keys(item1.below).length)
                              ) {
                                for (const [key2, item2] of Object.entries(
                                  item1.below
                                )) {
                                  if (key2.includes('menu_link_content:')) {
                                    let uniqueID2 = key1.substring(
                                      key2.length - 7
                                    );
                                    inner_lvl2.push({
                                      title: item2.title,
                                      href: item2.url,
                                      key: uniqueID2,
                                    });
                                  }
                                }
                                parent['below'] = inner_lvl2;
                              }
                              inner_lvl1.push(parent);
                              inner_lvl2 = [];
                            }
                          }
                        }

                        return (
                          <Accordion
                            style={{
                              background: 'transparent',
                              paddingBottom: '16px',
                            }}
                            expanded={expanded === `nav-${uniqueID}`}
                            key={`acc-${uniqueID}`}
                            onClick={() => {
                              if (expanded === `nav-${uniqueID}`) {
                                handleNavbarChange(`nav-${uniqueID}`, false);
                                setActiveInnerItem(null);
                                return;
                              }
                              handleNavbarChange(`nav-${uniqueID}`, true);
                              setActiveInnerItem(key);
                            }}
                          >
                            <AccordionSummary
                              aria-controls={`${uniqueID}-content`}
                              id={`${uniqueID}-header`}
                            >
                              <span>{item.title}</span>
                              <svg
                                width="22px"
                                height="14px"
                                viewBox="0 0 22 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  opacity="0.5"
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.56667 0.26683L1.31174e-07 2.8335L11 13.8335L22 2.8335L19.4333 0.26683L11 8.70016L2.56667 0.26683Z"
                                  fill="#C4C4C4"
                                />
                              </svg>
                            </AccordionSummary>
                          </Accordion>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              </Hidden>
              <Hidden smDown>
                <Box
                  displayPrint="none"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Button
                    className={classes.headerCtaDesktop}
                    size="large"
                    href="/living/homes/pre-owned"
                    disableElevation
                    variant="contained"
                    color="primary"
                  >
                    FIND A HOME
                  </Button>
                </Box>
              </Hidden>
            </Box>
            {activeInnerItem && (
              <div
                className="child-accordion"
                style={{
                  backgroundColor: 'white',
                  position: 'absolute',
                  right: 0,
                  top: 3,
                  paddingTop: '80px',
                  width: '100vw',
                  background: 'white',
                  zIndex: '100',
                }}
              >
                <AccordionDetails
                  style={{
                    backgroundColor: 'white',
                    minHeight: '50vh',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <HoverDropdownMenu
                    menu={menu['#items']}
                    activeId={activeInnerItem}
                    setActiveInnerItem={setActiveInnerItem}
                  />
                </AccordionDetails>
              </div>
            )}
            <Hidden mdUp>
              <Box displayPrint="none">
                <IconButton
                  className={classes.iconStyles}
                  ref={anchorRef}
                  aria-controls={open ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={handleToggle}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                className={classes.popoverStyles}
              >
                {main_menu}
              </Popper>
            </Hidden>
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
}

export function transformMenuData(data) {
  const dropdownMenu = [];

  for (const key in data['#items']) {
    const item = data['#items'][key];
    const headline = item.title;
    const variants = [];

    if (item.below) {
      for (const subKey in item.below) {
        const subItem = item.below[subKey];
        variants.push({
          title: subItem.title,
          description: '', // Add relevant descriptions if available
          url: subItem.url,
        });
      }
    }

    dropdownMenu.push({
      headline,
      variants,
    });
  }

  return dropdownMenu;
}

function MenuHeadline({ headline, url }) {
  const classes = useStyles();

  return (
    <Link href={url} passHref>
      <Box className={classes.headlineContainer}>
        <Box>
          <Typography className={classes.headline}>{headline}</Typography>
        </Box>
        <div
          style={{
            marginLeft: '10px',
            height: 18,
            width: 24,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="18"
            viewBox="0 0 24 16"
            fill="none"
          >
            <path
              d="M23.7071 8.70711C24.0976 8.31658 24.0976 7.68342 23.7071 7.29289L17.3431 0.928932C16.9526 0.538408 16.3195 0.538408 15.9289 0.928932C15.5384 1.31946 15.5384 1.95262 15.9289 2.34315L21.5858 8L15.9289 13.6569C15.5384 14.0474 15.5384 14.6805 15.9289 15.0711C16.3195 15.4616 16.9526 15.4616 17.3431 15.0711L23.7071 8.70711ZM0 9H23V7H0V9Z"
              fill="#2A5931"
            />
          </svg>
        </div>
      </Box>
    </Link>
  );
}
